import React, { useRef, useState, useEffect } from 'react';

const CameraScreen = ({ onCapture, onClose, onGallerySelect }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [stream, setStream] = useState(null);
  const [hasCamera, setHasCamera] = useState(true);
  const [flashMode, setFlashMode] = useState('off');
  const fileInputRef = useRef(null);

  useEffect(() => {
    startCamera();
    return () => {
      stopCamera();
    };
  }, []);

  const startCamera = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
        audio: false
      });
      setStream(mediaStream);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
      setHasCamera(true);
    } catch (err) {
      console.error('Camera access error:', err);
      setHasCamera(false);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
    }
  };

  const capturePhoto = () => {
    if (!videoRef.current || !canvasRef.current) return;

    const video = videoRef.current;
    const canvas = canvasRef.current;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0);

    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], 'receipt.jpg', { type: 'image/jpeg' });
        stopCamera();
        onCapture(file);
      }
    }, 'image/jpeg', 0.95);
  };

  const handleGalleryClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      stopCamera();
      onCapture(file);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      background: '#000',
      paddingTop: '36px'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 16px',
        flexShrink: 0,
        zIndex: 10
      }}>
        <button
          onClick={() => {
            stopCamera();
            onClose();
          }}
          style={{
            width: '28px',
            height: '28px',
            border: '1.5px solid #fff',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            color: '#fff',
            background: 'transparent',
            cursor: 'pointer'
          }}
        >✕</button>
        <button
          onClick={() => setFlashMode(flashMode === 'off' ? 'on' : 'off')}
          style={{
            width: '28px',
            height: '28px',
            border: '1.5px solid #fff',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            color: flashMode === 'on' ? '#ffd700' : '#fff',
            background: 'transparent',
            cursor: 'pointer'
          }}
        >⚡</button>
      </div>

      {/* Camera preview */}
      <div style={{
        flex: 1,
        position: 'relative',
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }}>
        {hasCamera ? (
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        ) : (
          <div style={{
            color: '#999',
            fontSize: '12px',
            textAlign: 'center',
            padding: '20px'
          }}>
            カメラにアクセスできません<br/>
            ギャラリーから画像を選択してください
          </div>
        )}
        <canvas ref={canvasRef} style={{ display: 'none' }} />
      </div>

      {/* Controls */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '32px',
        padding: '16px 0 24px',
        flexShrink: 0,
        background: '#000'
      }}>
        <button
          onClick={handleGalleryClick}
          style={{
            width: '36px',
            height: '36px',
            border: '1.5px solid #aaa',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '9px',
            color: '#fff',
            background: 'transparent',
            cursor: 'pointer'
          }}
        >写真</button>

        <button
          onClick={capturePhoto}
          disabled={!hasCamera}
          style={{
            width: '52px',
            height: '52px',
            borderRadius: '50%',
            border: '3px solid #fff',
            position: 'relative',
            background: 'transparent',
            cursor: hasCamera ? 'pointer' : 'not-allowed',
            opacity: hasCamera ? 1 : 0.5
          }}
        >
          <div style={{
            position: 'absolute',
            inset: '4px',
            borderRadius: '50%',
            border: '1.5px solid #aaa'
          }} />
        </button>

        <div style={{ width: '36px' }} />
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default CameraScreen;
